import { render, staticRenderFns } from "./general-terms.vue?vue&type=template&id=64f406dc&"
import script from "./general-terms.vue?vue&type=script&lang=js&"
export * from "./general-terms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports